import { PARENT_EVENTS } from 'constants/index';
import { ToolErrorCode } from 'constants/toolError';

function postToolError(code: ToolErrorCode, error?: unknown) {
	console.log('Posting tool error to parent window:', { code, error });
	window.parent.postMessage(
		{
			id: 'TOOL_ERROR',
			code,
			error: (error as any)?.response?.data?.message ?? (error instanceof Error ? error.message : String(error ?? '')),
		},
		'*'
	);
}

function postFullViewToggle(fullScreenEnabled: boolean) {
	window.parent.postMessage(
		{ id: PARENT_EVENTS.FULL_VIEW_TOGGLE, detail: { fullScreenEnabled } },
		'*'
	);
}

function postSaveDesignTrigger() {
	window.parent.postMessage({ id: PARENT_EVENTS.SAVE_DESIGN_TRIGGER }, '*');
}

type SaveDesignDetail = {
	design: Record<string, unknown>;
	onlySync?: boolean;
};

function postSaveDesign(detail: SaveDesignDetail) {
	window.parent.postMessage({ id: PARENT_EVENTS.SAVE_HOUSE, detail }, '*');
}

export {
	postFullViewToggle,
	postSaveDesign,
	postSaveDesignTrigger,
	postToolError,
};
